import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dt-bank-offers',
  templateUrl: './bank-offers.component.html',
  styleUrls: ['./bank-offers.component.css'],
  standalone: false
})
export class BankOffersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
